export const isOfficialTownsToken = (contractAddress: string) => {
    return contractAddress.toLowerCase() === TOWNS_TOKEN_ADDRESS.toLowerCase()
}

export const TOWNS_TOKEN_ADDRESS = '0x00000000A22C618fd6b4D7E9A335C4B96B189a38'
